import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import View from '../../../../assets/img/svg/view.svg';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg"
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Pagination from "../../../custom/Pagination";
import $ from "jquery"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { getMOM_ListView, getMOM_Materials, deletemultiMOM } from "../../../../actions/MOMAction";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import axios from "axios";
import { ThreeDRotationSharp } from "@material-ui/icons";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

//const ListViewMOM = () => {
class ListViewMOM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            ProjectId: 0,
            hide: [],
            index:1,
            UserRole: '',
            isAccess: false,
            MOM_ListView: [],
            Delete: [],
            searchData: {
                ProjectId: 0,
                Material: "",
                PageNumber: 1,
                PageSize: 100,
                SortBy: 'material',
                SortOrder: 'asc'
            },
        }
    }


    componentDidMount() {
        const { dispatch } = this.props;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.ProjectId = localStorage.getItem("DashId");
        this.setState({})
        if (this.state.UserRole === "Admin" || this.state.UserRole == "Supervisor") {
            this.setState({ isAccess: true })
        }
        else {
            this.setState({ isAccess: false })
        }
        dispatch(getMOM_Materials())
        dispatch(getlookupdocinfo("Matrix"))
        localStorage.removeItem("MOMEditId")
        this.dataTable(this.state.searchData, this.state.ProjectId);
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Matrix1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Matrix").addClass("d-none");
        $("#Matrix").removeClass("d-block");
        $("#MOML").removeClass("active-color");
        $("#MOMT").removeClass("fw-bolder");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

    };
    resize1 = () => {
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Matrix1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Matrix").removeClass("d-none");
        $("#Matrix").addClass("d-block");
        $("#MOML").addClass("active-color");
        $("#MOMT").addClass("fw-bolder");
    }
    dataTable = (data, id) => {
        let apiUrl = API.MOM_LISTVIEW + "?projectId=" + id + "&Material=" + data.Material + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder +'&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    destroyDataTable("staffTable")
                    this.props.dispatch({ type: "MOM_LISTVIEW", data: response.data });
                    this.setState({
                        MOM_ListView: response.data,
                    })
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isAccess === false ? false : true }], "", "", "", "",[this.state.index,data.SortOrder]);
                }
                else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
            });

    }
    handleCheckboxChange = (e, x) => {
        const { Delete } = this.state;
        if (Delete.length == 0) {
            Delete.push(x)
        }
        else {
            if (Delete.filter((i) => i == x).length == 1) {
                Delete.map((i, ind) => (
                    i == x ?
                        Delete.splice(ind, 1)
                        : ""
                ))
            } else {
                Delete.push(x)
            }
        }
        this.setState({})
        if (Delete.length == 1) {
            localStorage.setItem("MOMEditId", Delete[0])
        }

        this.state.hide = Delete.length;
        this.setState({})

    }
    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/matrixofmaterials/addnew")
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/matrixofmaterials/edit")
    };

    ViewPage = () => {
        this.props.navigate("/matrixofmaterials/view")
    };
    DeleteItem = () => {

        let tempData = [];
        const { Delete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemultiMOM(Delete, this.state.ProjectId, this.state.UserRole)
        this.state.hide = 0;
        this.setState({});
        $('input[type=checkbox]').prop('checked', false);
        // this.props.dispatch(getMOM_ListView(this.state.searchData, this.state.ProjectId))

    }
    deletemultiMOM = (data, id, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }

        let apiUrl = API.MOM_LISTVIEW + '/ids?' + ids + '&modify=' + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })

        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.Delete = [];
                    this.setState({});
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Material = e.target.value;
        this.setState({});
    };
    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Material = e;
        this.setState({});
    };
    Search = () => {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='material'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            Material: '',
            PageNumber: 1,
            PageSize: 100,
            SortBy: 'material',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
        //this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    handleSort = (data,ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index:ind
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);

    }
    render() {
        let { classes, menuToggle, MASTERDATA_MATERIAL, MOM_ListView } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"MAT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="MAT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-3 mt-5">
                                    <h4>Matrix of Materials - Disposition</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isAccess ? <>
                        {this.state.isMobile ? <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center">
                                        <button className={classes.button} disabled={this.state.isAccess === true ? this.state.hide == 1 ? false : true : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                    </td>
                                    <td className="border-right text-center">
                                        <button className={`${classes.button}`} disabled={this.state.isAccess === true ? this.state.hide > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>
                                    </td>
                                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                        <button className={`${classes.button} px-0`} onClick={this.AddNew} disabled={this.state.isAccess === true ? false : true}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess == true ? '' : '0.5' }}></i>Add New</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                            :

                            <div className="row  border-bottom">
                                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                    <button className={`${classes.button} pl-3`} disabled={this.state.isAccess === true ? this.state.hide == 1 ? false : true : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide == 1 ? '' : '0.5' : '0.5' }}></img>&nbsp;Edit</button>
                                    <button className={`${classes.button}`} disabled={this.state.isAccess === true ? this.state.hide > 0 ? false : true : true} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.isAccess === true ? this.state.hide > 0 ? '' : '0.5' : '0.5' }}></img>&nbsp;Delete</button>
                                    <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                        <button className={classes.button} disabled={this.state.isAccess === true ? false : true} onClick={this.AddNew}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess == true ? '' : '0.5' }}></i>Add New</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                        :
                        <></>}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">

                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Matrix of Materials - Disposition</h6>}
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" style={{ minWidth: '70px' }} data-target="#custom-modal" className={`${classes.button} float-end`}><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive pb-3" style={{ width: "100%" }}>
                                <table id="staffTable" className="table">
                                    <thead>
                                        <tr className="">
                                            <th className="border-left" width="3%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right border-left"  width="10%" style={{ minWidth: '70px' }}onClick={() => this.handleSort('material',1)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Material</span></th>
                                            <th className="border-right" width="5%" onClick={() => this.handleSort('totalquantitymt',1)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total Quantity in MT</span></th>
                                            <th className="border-right" width="5%" onClick={() => this.handleSort('reusedinmt',2)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Reused in MT</span></th>
                                            <th className="border-right" width="5%" onClick={() => this.handleSort('recycledinmt',3)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Recycled in MT</span></th>
                                            <th className="border-right" width="5%" onClick={() => this.handleSort('landfillinmt',4)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Landfill in MT</span></th>
                                            <th className="border-right" width="" style={{ minWidth: '100px' }} onClick={() => this.handleSort('delivery',5)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Delivery</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.MOM_ListView?.Matrix && this.props.MOM_ListView?.Matrix.map((i, v) => (<>
                                            {i.Materials && i.Materials.map((i, v) => (<>
                                                <tr>
                                                    <td className="spandoc-td align-middle text-center border-left"><input type="checkbox" disabled={this.state.isAccess == true ? false : true} style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id)} /></td>
                                                    <td className="spandoc-td border-right align-middle border-left">{i.Material}</td>
                                                    <td className="spandoc-td border-right align-middle text-right">{i.TotalQuantity}</td>
                                                    <td className="spandoc-td border-right align-middle text-right">{i.ReusedInMT}</td>
                                                    <td className="spandoc-td border-right align-middle text-right">{i.RecycledInMT}</td>
                                                    <td className="spandoc-td border-right align-middle text-right">{i.LandFillInMT}</td>
                                                    <td className="spandoc-td border-right align-middle ">{i.Delivery}</td>
                                                </tr>
                                            </>))}
                                        </>)
                                        )}
                                    </tbody>
                                    <tfoot>
                                        {this.state.MOM_ListView?.Matrix && this.state.MOM_ListView?.Matrix.map((i, v) => (<>
                                            <tr className="table-active">
                                                <td colSpan={2} className="spandoc-td border-right border-left" align="center">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>Total(MT)</span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar " style={{ color: "#000000" }}>{i.TotalQuantity}</span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{i.TotalReused}</span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{i.TotalRecycled}</span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{i.TotalLandFilled}</span>
                                                </td>
                                                <td className="spandoc-td border-right">
                                                </td>
                                            </tr>
                                            <tr className="table-active">
                                                <td className="border-left">
                                                </td>
                                                <td className={this.state.isAccess===false?"border-left":""}>
                                                </td>
                                                <td className="border-right spandoc-td text-right" align="center">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>
                                                        Total %
                                                    </span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{parseFloat(i.TotalReusedPercenetage).toFixed(2)}%</span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{parseFloat(i.TotalRecycledPercentage).toFixed(2)}%</span>
                                                </td>
                                                <td className="spandoc-td border-right text-right">
                                                    <span className="spanTopBar" style={{ color: "#000000" }}>{parseFloat(i.TotalLandFilledPercentage).toFixed(2)}%</span>
                                                </td>
                                                <td className="border-right">
                                                </td>
                                            </tr>
                                        </>)
                                        )}
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>                            <div className="modal-content border-radius">
                            <div className="modal-header">
                                <div className="row m-0">
                                    <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                    <div className="col-12">
                                        <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                            <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body p-4">
                                <form id="myform">
                                    <div className="form-group row">
                                        <div className="col-5 m-auto">
                                            <label htmlFor="name">Material</label></div>
                                        <div className="col-7">
                                            <div className="autocomplete-wrappers">
                                                <Autocomplete
                                                    contentEditable={true}
                                                    value={this.state.searchData.Material}
                                                    inputProps={{
                                                        placeholder: "Material",
                                                    }}
                                                    items={MASTERDATA_MATERIAL ?? []}
                                                    getItemValue={(item) => item.Name}
                                                    shouldItemRender={this.renderProjectNames.bind(this)}
                                                    renderMenu={(item) => (
                                                        <div className="dropdowns d-block" >{item}</div>
                                                    )}
                                                    renderInput={(props) => {
                                                        return (
                                                            <input
                                                                className="form-control border-radius"
                                                                id="exampleFormControlInput1"
                                                                {...props}
                                                                style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                            />
                                                        );
                                                    }}
                                                    renderItem={(item, isHighlighted) => (
                                                        <div
                                                            className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                }`}
                                                        >
                                                            {item.Name}
                                                        </div>
                                                    )}
                                                    onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                    onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row text-center mt-4">
                                        {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                        <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                            <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                        </div>
                                        <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                            <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row w-100">
                    <div className="col-sm-12"> <Pagination /></div>
                </div> */}
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        MOM_ListView: state.MOMReducer.MOM_ListView || [],
        MASTERDATA_MATERIAL: state.MasterDataReducer.Lookup_data || [],
    };
}

ListViewMOM.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewMOM))
);
